import React from "react";
import { Leaf, ArrowRight, Phone } from "lucide-react";

const PRODUCTS = [
  { name: "Courges fraîches", desc: "Courges locales, riches en nutriments et parfaites pour une alimentation saine." },
  { name: "Ananas frais", desc: "Ananas juteux et sucrés, récoltés à maturité." },
  { name: "Avocats frais", desc: "Avocats crémeux et savoureux, idéaux pour une alimentation équilibrée." },
  { name: "Bananes plantain", desc: "Bananes plantain fermes et nutritives, idéales pour la cuisson." },
  { name: "Mangues fraîches", desc: "Mangues sucrées et parfumées, fraîchement récoltées." },
  { name: "Kiwis frais", desc: "Kiwis riches en vitamines C pour un boost d'énergie naturel." },
];

const VIVRIERS_IMG =
  "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/pqqtdb89_D28BE3F4-EA50-411E-80CB-8C77DEDF8DA9.jpeg";

export default function VivriersSection() {
  return (
    <section
      id="vivriers"
      data-testid="vivriers-section"
      className="bg-white py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-14">
          <div className="lg:col-span-7">
            <div className="kms-overline mb-4 flex items-center gap-4">
              <span className="font-heading font-black text-sm text-[#D90429]">03</span>
              <span className="h-px w-12 bg-[#D90429]" />
              <span>Produits vivriers</span>
            </div>
            <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-[#0A1128] leading-[1.05]">
              Une sélection <span className="text-[#16A34A]">fraîche</span> et de qualité.
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#6B7280] text-base self-end leading-relaxed">
            KMS Services Plus commercialise une gamme complète de produits
            vivriers frais et locaux, directement issus des meilleurs
            producteurs ivoiriens. Livraison rapide, conditionnement
            professionnel.
          </p>
        </div>

        {/* Hero composite image */}
        <div className="relative overflow-hidden bg-[#F9FAFB] border border-gray-200 shadow-sm mb-12">
          <img
            src={VIVRIERS_IMG}
            alt="Catalogue produits vivriers KMS - Courges, Ananas, Avocats, Bananes plantain, Mangues, Kiwis"
            className="w-full h-auto object-contain"
            data-testid="vivriers-hero-image"
          />
        </div>

        {/* Individual product cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRODUCTS.map((p, i) => (
            <div
              key={p.name}
              data-testid={`vivrier-card-${i}`}
              className="group relative p-6 bg-white border border-gray-200 hover:border-[#16A34A] hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center bg-[#16A34A]/10 text-[#16A34A] group-hover:bg-[#16A34A] group-hover:text-white transition-all rounded-full">
                  <Leaf size={20} strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg text-[#0A1128] tracking-tight uppercase">
                    {p.name}
                  </h3>
                  <p className="mt-2 text-sm text-[#6B7280] leading-relaxed">
                    {p.desc}
                  </p>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-[#16A34A] group-hover:w-full transition-all duration-500" />
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-6 p-8 bg-[#0A1128] text-white">
          <div className="flex-1">
            <div className="kms-overline mb-2" style={{ color: "#16A34A" }}>
              Passer commande
            </div>
            <h3 className="font-heading font-bold text-xl sm:text-2xl tracking-tight">
              Besoin de produits vivriers en gros ou au détail ?
            </h3>
            <p className="mt-2 text-white/65 text-sm">
              Notre équipe commerciale vous propose des tarifs adaptés à votre
              volume.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href="#contact"
              data-testid="vivriers-quote-btn"
              className="inline-flex items-center gap-2 bg-[#16A34A] text-white px-6 py-3 font-bold tracking-wide hover:bg-white hover:text-[#0A1128] transition-all duration-300"
            >
              Demander un devis <ArrowRight size={16} />
            </a>
            <a
              href="tel:+22505053527272"
              data-testid="vivriers-call-btn"
              className="inline-flex items-center gap-2 border border-white/30 text-white px-6 py-3 font-bold tracking-wide hover:border-[#16A34A] hover:text-[#16A34A] transition-all"
            >
              <Phone size={16} /> Appeler
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
